import styled, { css } from "styled-components";

export const PhotoGalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  max-width: 100%;
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  padding: 1rem;
`;

type ImageGalleryProps = {
  galleryGridTemplateColumns?: string;
  galleryContainerHeight?: string;
}

export const ImageGalleryContainer = styled.div<ImageGalleryProps>`
  display: grid;
  grid-gap: 0.7rem;
  width: 100%;
  
  ${({ galleryGridTemplateColumns }) => css`
    grid-template-columns: ${galleryGridTemplateColumns ?? '1fr 1fr'};
    height: fit-content;
  `}
`;

type GalleryPictureProps = {
  pictureWidth?: `${number}px` | `${number}rem`;
  pictureHeight?: `${number}px` | `${number}rem`;
}

export const GalleryPicture = styled.img<GalleryPictureProps>`
  ${({ pictureWidth, pictureHeight }) => css`
    width: ${pictureWidth ?? '100%'};
    height: ${pictureHeight ?? '6rem'};
  `}

  cursor: pointer;
  object-fit: cover;
`;
